export const Soil = {
  SANDY_LOAM: 'SandyLoam',
  CLAY_LOAM: 'ClayLoam',
  CLAY: 'Clay',
}
